import { AuthResponseDto, RegisterDto } from "@reactive-resume/dto";
import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

import { axios } from "@/client/libs/axios";
import { queryClient } from "@/client/libs/query-client";
import { useAuthStore } from "@/client/stores/auth";
import { trackEvent } from "@/client/utils/analytics";

export const register = async (data: RegisterDto) => {
  try {
    const response = await axios.post<AuthResponseDto, AxiosResponse<AuthResponseDto>, RegisterDto>(
      "/auth/register",
      data,
    );
    trackEvent({
      userType: "youth",
      apiName: "register",
      userId: response.data.user?.id,
      success: true,
    });
    return response.data;
  } catch (error) {
    trackEvent({ userType: "youth", apiName: "register", success: false });
    throw error;
  }
};

export const useRegister = () => {
  const setUser = useAuthStore((state) => state.setUser);

  const {
    error,
    isPending: loading,
    mutateAsync: registerFn,
  } = useMutation({
    mutationFn: register,
    onSuccess: (data) => {
      setUser(data.user);
      queryClient.setQueryData(["user"], data.user);
    },
  });

  return { register: registerFn, loading, error };
};
